import styled from 'styled-components';

export const Container = styled.section`
  .faq {
    padding: 68px 0 68px;

    .collapsable-container__button {
      outline: none;
    }
  }
`;

export default Container;
